import { render, staticRenderFns } from "./AppField.vue?vue&type=template&id=b461e80c&scoped=true&"
import script from "./AppField.vue?vue&type=script&lang=ts&"
export * from "./AppField.vue?vue&type=script&lang=ts&"
import style0 from "./AppField.vue?vue&type=style&index=0&id=b461e80c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b461e80c",
  null
  
)

export default component.exports